const pesoFmt = new Intl.NumberFormat("en-PH", { style: "currency", currency: "PHP", minimumFractionDigits: 2 });
const pesoWhole = new Intl.NumberFormat("en-PH", { style: "currency", currency: "PHP", maximumFractionDigits: 0 });

export const php = (n) => pesoFmt.format(Number(n) || 0);
export const phpWhole = (n) => pesoWhole.format(Number(n) || 0);

export function phpShort(n) {
  const v = Number(n) || 0;
  if (Math.abs(v) >= 1e9) return `₱${(v / 1e9).toFixed(2)}B`;
  if (Math.abs(v) >= 1e6) return `₱${(v / 1e6).toFixed(2)}M`;
  if (Math.abs(v) >= 1e3) return `₱${(v / 1e3).toFixed(0)}K`;
  return `₱${v.toFixed(0)}`;
}

export function phone(p) {
  const d = String(p || "").replace(/\D/g, "");
  let n = d;
  if (n.startsWith("63") && n.length === 12) n = "0" + n.slice(2);
  if (n.length === 11 && n.startsWith("09")) return `+63 ${n.slice(1, 4)} ${n.slice(4, 7)} ${n.slice(7)}`;
  return p || "";
}

export function date(s) {
  if (!s) return "—";
  return new Date(s).toLocaleDateString("en-PH", { year: "numeric", month: "short", day: "numeric" });
}

export function dateTime(s) {
  if (!s) return "—";
  return new Date(s).toLocaleString("en-PH", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
}

export const STATUS_STYLES = {
  open: "bg-slate-100 text-slate-700 border-slate-200",
  won: "bg-emerald-50 text-emerald-700 border-emerald-200",
  lost: "bg-red-50 text-red-700 border-red-200",
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  pending_approval: "bg-amber-50 text-amber-700 border-amber-200",
  approved: "bg-blue-50 text-blue-700 border-blue-200",
  rejected: "bg-red-50 text-red-700 border-red-200",
  sent: "bg-indigo-50 text-indigo-700 border-indigo-200",
  accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  declined: "bg-red-50 text-red-700 border-red-200",
};

export const label = (s) => String(s || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export function toLocalInput(iso) {
  const d = iso ? new Date(iso) : new Date(Date.now() + 86400000);
  const off = d.getTimezoneOffset();
  return new Date(d.getTime() - off * 60000).toISOString().slice(0, 16);
}
